import React, { useState } from "react";
import {
  Input,
  Button,
  Form,
  Upload,
  Steps,
  message,
  notification,
  Select,
  Modal,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import { createCompany } from "../../../API/Admin/company";
import "./style.css";

const AddRecoveryCompany = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formDataStep1, setFormDataStep1] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);

  const steps = [{ title: "" }, { title: "" }];

  const handleBack = () => {
    if (current > 0) {
      setCurrent(current - 1);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    message.info("Changes canceled");
  };

  const handleNext = async () => {
    try {
      const values = await form.validateFields();
      setFormDataStep1(values);
      setCurrent(current + 1);
    } catch (err) {
      message.error(
        err.errorFields?.[0]?.errors?.[0] || "Please fill all required fields",
      );
    }
  };

  const errorNotification = (msg) => {
    messageApi.error(msg);
  };

  const handleSave = async (override = false) => {
    try {
      let allValues;
      const isDefault = form.getFieldValue("is_default");

      if (override) {
        allValues = pendingValues || {
          ...formDataStep1,
          ...form.getFieldsValue(),
        };
      } else {
        const valuesStep2 = await form.validateFields();
        allValues = { ...formDataStep1, ...valuesStep2 };

        if (isDefault === true || isDefault === "true") {
          setPendingValues(allValues);
          setIsModalOpen(true);
          return;
        }
      }

      if (!allValues || !allValues.company_name) {
        message.error("Form data is incomplete. Please try again.");
        return;
      }

      setLoading(true);

      const formData = new FormData();
      formData.append("company_name", allValues.company_name);
      formData.append("company_address", allValues.company_address);
      formData.append("registration_number", allValues.registration_number);
      formData.append("is_default", isDefault);
      formData.append("coverage_area", allValues.coverage_area || "");
      formData.append("primary_contact_person", allValues.contactName);
      formData.append("primary_contact_number", allValues.primaryNumber);
      formData.append("secondary_contact_number", allValues.secondaryContact);
      formData.append("email_address", allValues.email);
      formData.append("service_level_agreement_details", allValues.sla);
      formData.append("status", allValues.status);

      if (override) {
        formData.append("override_default", 1);
      }

      if (allValues.logo && allValues.logo.length > 0) {
        const file = allValues.logo[0]?.originFileObj || allValues.logo[0];
        if (file) formData.append("logo", file);
      }

      const res = await createCompany(formData);

      if (Math.floor(res.status / 100) === 2) {
        messageApi.success("Company created successfully!");
        setIsModalOpen(false);
        setPendingValues(null);
        setTimeout(() => navigate("/recovery-company"), 2000);
      } else {
        errorNotification(res?.data?.message || "Failed to create company.");
      }
    } catch (err) {
      setLoading(false);

      if (err.errorFields) {
        return;
      }

      const errorData = err.response?.data;

      if (errorData && typeof errorData === "object") {
        const fieldErrors = Object.keys(errorData).map((key) => ({
          name: key,
          errors: errorData[key],
        }));

        form.setFields(fieldErrors);

        const firstKey = Object.keys(errorData)[0];
        const firstMessage = errorData[firstKey]?.[0];
        errorNotification(firstMessage);

        return;
      }

      errorNotification("Something went wrong");
    } finally {
      if (!isModalOpen) setLoading(false);
    }
  };
  return (
    <div className="add-company">
      {contextHolder}
      <div className="steps-container">
        <Steps current={current} items={steps} />
      </div>
      <Form form={form} layout="vertical">
        {current === 0 && (
          <>
            <div className="add-container">
              <div className="heading">Company Information</div>
              <div className="details">
                <div className="input-group">
                  <div className="title">Company Name</div>
                  <Form.Item
                    name="company_name"
                    rules={[
                      { required: true, message: "Please enter company name" },
                    ]}
                  >
                    <Input placeholder="Enter company name" />
                  </Form.Item>
                </div>

                <div className="input-group">
                  <div className="title">Registration Number</div>
                  <Form.Item
                    name="registration_number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter registration number",
                      },
                    ]}
                  >
                    <Input placeholder="Enter registration number" />
                  </Form.Item>
                </div>

                <div className="input-group">
                  <div className="title">Coverage Area</div>
                  <Form.Item
                    name="coverage_area"
                    rules={[
                      {
                        required: true,
                        message: "Please enter coverage area",
                      },
                    ]}
                  >
                    <Input placeholder="Add Area" />
                  </Form.Item>
                </div>

                <div className="input-group">
                  <div className="title">Office Address</div>
                  <Form.Item
                    name="company_address"
                    rules={[
                      {
                        required: true,
                        message: "Please enter office address",
                      },
                    ]}
                  >
                    <Input placeholder="Enter office address" />
                  </Form.Item>
                </div>
              </div>

              <div className="details">
                <div className="input-group">
                  <div className="title">Default</div>
                  <Form.Item
                    name="is_default"
                    rules={[
                      {
                        required: true,
                        message: "Please select default option",
                      },
                    ]}
                  >
                    <Select placeholder="Select Option">
                      <Select.Option value={true}>True</Select.Option>
                      <Select.Option value={false}>False</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                <div className="input-group">
                  <div className="title">Status</div>
                  <Form.Item
                    name="status"
                    rules={[
                      { required: true, message: "Please select status" },
                    ]}
                  >
                    <Select placeholder="Select Status">
                      <Select.Option value="Active">Active</Select.Option>
                      <Select.Option value="Inactive">Inactive</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className="input-group">
                <Form.Item
                  name="logo"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e && e.fileList}
                  rules={[
                    {
                      required: true,
                      message: "Please attach a company logo",
                    },
                  ]}
                >
                  <Upload
                    accept=".png,.jpg,.jpeg,.jfif"
                    listType="picture"
                    maxCount={1}
                    beforeUpload={(file) => {
                      const allowedExtensions = [
                        "png",
                        "jpg",
                        "jpeg",
                        "jfif",
                      ];
                      const fileExtension = file.name
                        .split(".")
                        .pop()
                        .toLowerCase();

                      if (!allowedExtensions.includes(fileExtension)) {
                        message.error(
                          "Only image files (.png, .jpg, .jpeg, .jfif) are allowed",
                        );
                      }

                      return false;
                    }}
                  >
                    <Button className="upload-btn" icon={<PlusOutlined />}>
                      Attach Company Logo
                    </Button>
                  </Upload>
                </Form.Item>
              </div>
            </div>
            <div className="form-actions">
              <Button onClick={handleCancel}>Cancel</Button>
              <Button
                className="save-btn"
                type="primary"
                onClick={handleNext}
                loading={loading}
              >
                Next
              </Button>
            </div>
          </>
        )}
        {current === 1 && (
          <>
            <div className="add-container">
              <div className="heading">Contact Person</div>
              <div className="details">
                <div className="input-group">
                  <div className="title">Primary Contact Person</div>
                  <Form.Item
                    name="contactName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter primary contact person",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Name" />
                  </Form.Item>
                </div>

                <div className="input-group">
                  <div className="title">Primary Contact Number</div>
                  <Form.Item
                    name="primaryNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please enter primary contact number",
                      },
                    ]}
                  >
                    <PhoneInput
                      country={"jm"}
                      placeholder="+1 (876) 123-4567"
                      inputClass="phone-input"
                      specialLabel={false}
                      inputStyle={{ width: "100%" }}
                      onChange={(value) => {
                        form.setFieldsValue({
                          primaryNumber: value.startsWith("+")
                            ? value
                            : `+${value}`,
                        });
                      }}
                    />
                  </Form.Item>
                </div>

                <div className="input-group">
                  <div className="title">Email Address</div>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your email address",
                      },
                      {
                        type: "email",
                        message: "Please enter a valid email address",
                      },
                    ]}
                  >
                    <Input placeholder="Enter email address" type="email" />
                  </Form.Item>
                </div>

                <div className="input-group">
                  <div className="title">Secondary Contact Number</div>
                  <Form.Item
                    name="secondaryContact"
                    rules={[
                      {
                        required: true,
                        message: "Please enter secondary contact number",
                      },
                    ]}
                  >
                    <PhoneInput
                      country={"jm"}
                      placeholder="+1 (876) 123-4567"
                      inputClass="phone-input"
                      specialLabel={false}
                      inputStyle={{ width: "100%" }}
                      onChange={(value) => {
                        form.setFieldsValue({
                          secondaryContact: value.startsWith("+")
                            ? value
                            : `+${value}`,
                        });
                      }}
                    />
                  </Form.Item>
                </div>

                <div className="input-group">
                  <div className="title">
                    Service Level Agreement (SLA) Details
                  </div>
                  <Form.Item
                    name="sla"
                    rules={[
                      {
                        required: true,
                        message: "Please enter SLA details",
                      },
                    ]}
                  >
                    <Input placeholder="Enter SLA details" type="text" />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="form-actions">
              <Button onClick={handleBack}>Back</Button>
              <Button
                className="save-btn"
                type="primary"
                onClick={() => handleSave()}
                loading={loading}
              >
                Save
              </Button>
            </div>
          </>
        )}
      </Form>
      <Modal
        title="Override Default Company?"
        open={isModalOpen}
        onOk={() => handleSave(true)}
        onCancel={() => setIsModalOpen(false)}
        okText="Yes, Override"
        cancelText="No"
        confirmLoading={loading}
      >
        <p>
          A default company already exists. Are you sure you want to make this
          company the default?
        </p>
      </Modal>
    </div>
  );
};

export default AddRecoveryCompany;
